<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">

          <!-- TOP BAR -->
          <div class="table-top">
            <button class="btn add" @click="openAddModal">
              {{$t('giftCard.addgift')}}
            </button>
          </div>

          <!-- TABLE -->
          <el-table
            :data="tableData"
            v-loading="loading"
            style="width:100%; margin-top:20px"
            @row-click="goToDetails"
          >
            <el-table-column prop="id" label="ID" width="80"/>

            <el-table-column :label="$t('giftCard.type')">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">{{$t('giftCard.online')}}</span>
                <span v-else>{{$t('giftCard.offline')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="value" :label="$t('giftCard.value')"/>

            <el-table-column prop="expiration_time" :label="$t('giftCard.exp')"/>

            <el-table-column prop="gift_cards_count" :label="$t('giftCard.generatedCards')"/>

            <el-table-column :label="$t('giftCard.active')">
              <template slot-scope="scope">
                <span v-if="scope.row.active == 1">{{$t('giftCard.yes')}}</span>
                <span v-else>{{$t('giftCard.no')}}</span>
              </template>
            </el-table-column>
          </el-table>

          <!-- PAGINATION -->
          <div class="pagination-wrapper" v-if="pagination.totalPages > 1">
            <el-pagination
              layout="prev, pager, next"
              :current-page="pagination.page"
              :page-size="pagination.perPage"
              :total="pagination.totalRecords"
              @current-change="handlePageChange"
            />
          </div>

        </div>
      </div>
    </div>

    <!-- ADD MODAL -->
    <vmodal name="addModal" :width="700" height="auto" :clickToClose="false">
      <div class="modal-content" style="padding: 20px;">
        <h3>{{$t('giftCard.modalTitle')}}</h3>

        <div class="form-group">
          <label>{{$t('giftCard.typeLabel')}}</label>
          <el-select v-model="form.type" :placeholder="$t('giftCard.selectType')" style="width:100%">
            <el-option :label="$t('giftCard.online')" :value="1" />
            <el-option :label="$t('giftCard.offline')" :value="2" />
          </el-select>
        </div>

        <div class="form-group">
          <label>{{$t('giftCard.valueLabel')}}</label>
          <el-input v-model="form.value" type="number" max="100000" />
        </div>

        <div class="form-group">
          <label>{{$t('giftCard.expLabel')}}</label>
          <el-input v-model="form.expiration_time" type="number" max="700" />
        </div>

        <div class="form-group" v-if="form.type === 2">
          <label>{{$t('giftCard.totalCards')}}</label>
          <el-input v-model="form.total_number" type="number" max="10000" />
        </div>

        <div class="dialog-footer" style="text-align:right; margin-top:20px">
          <el-button @click="$modal.hide('addModal')">{{$t('giftCard.cancel')}}</el-button>
          <el-button type="primary" @click="submitForm" :loading="saving">
            {{$t('giftCard.save')}}
          </el-button>
        </div>
      </div>
    </vmodal>

  </div>
</template>

<script>
import swal from 'sweetalert2'
export default {
  data () {
    return {
      loading: true,
      saving: false,
      tableData: [],

      pagination: {
        page: 1,
        perPage: 20,
        totalPages: 0,
        totalRecords: 0
      },

      form: {
        type: null,
        value: null,
        expiration_time: null,
        total_number: null
      }
    }
  },

  created () {
    this.fetchData()
    this.$bus.$on('refresh', this.handleRefresh)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },

  methods: {
    handleRefresh () {
      this.fetchData()
    },
    fetchData (page = 1) {
      this.loading = true

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page
      }

      this.apiRequest('/gift-cards', 'GET', data, (response) => {
        if (response.status) {
          this.tableData = response.data.data

          this.pagination.page = response.data.current_page
          this.pagination.perPage = response.data.per_page
          this.pagination.totalPages = response.data.last_page
          this.pagination.totalRecords = response.data.total
        }

        this.loading = false
      })
    },
    handlePageChange (page) {
      this.fetchData(page)
    },
    openAddModal () {
      this.form = {
        type: null,
        value: null,
        expiration_time: null,
        total_number: null
      }

      this.$modal.show('addModal')
    },
    submitForm () {
      // validare expiration_time (max 700)
      if (this.form.expiration_time && Number(this.form.expiration_time) > 700) {
        swal({
          title: this.$t('giftCard.errorTitle'),
          text: this.$t('giftCard.errorExpirationTimeMax'),
          icon: 'error',
          confirmButtonText: this.$t('giftCard.ok')
        })
        return
      }

      // validare total_number (max 10000)
      if (this.form.total_number && Number(this.form.total_number) > 10000) {
        swal({
          title: this.$t('giftCard.errorTitle'),
          text: this.$t('giftCard.errorTotalNumberMax'),
          icon: 'error',
          confirmButtonText: this.$t('giftCard.ok')
        })
        return
      }

      if (!this.form.type || !this.form.value) {
        swal({
          title: this.$t('giftCard.errorTitle'),
          text: this.$t('giftCard.errorRequired'),
          icon: 'error',
          confirmButtonText: this.$t('giftCard.ok')
        })
        return
      }

      if (this.form.type === 2 && !this.form.total_number) {
        swal({
          title: this.$t('giftCard.errorTitle'),
          text: this.$t('giftCard.errorOffline'),
          icon: 'error',
          confirmButtonText: this.$t('giftCard.ok')
        })
        return
      }

      this.saving = true

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        type: this.form.type,
        value: this.form.value,
        expiration_time: this.form.expiration_time,
        total_number: this.form.total_number
      }

      this.apiRequest('/gift-cards', 'POST', data, (response) => {
        this.saving = false

        if (response.status) {
          swal({
            title: this.$t('giftCard.successTitle'),
            text: this.$t('giftCard.successMessage'),
            icon: 'success',
            confirmButtonText: this.$t('giftCard.ok')
          }).then(() => {
            this.$modal.hide('addModal')
            this.fetchData()
          })
        } else {
          swal({
            title: this.$t('giftCard.errorTitle'),
            text: this.$t('giftCard.errorCreate'),
            icon: 'error',
            confirmButtonText: this.$t('giftCard.ok')
          })
        }
      })
    },
    goToDetails (row) {
      this.$router.push({
        path: `/gift-cards/${row.id}`
      })
    }

  }
}
</script>

<style>
.table-top {
  display:flex;
  justify-content: space-between;
}

.pagination-wrapper {
  margin-top:20px;
  text-align:center;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/GiftCard/GiftCard.vue